    <!-- Main Container -->
<div [ngClass]="{ 'width-70': formGroup }" class="card">
  <!-- Header -->
  <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
    Sponsors
    </h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <kendo-grid
      [kendoGridBinding]="sponsors"
      [pageSize]="25"
      [pageable]="true"
      [sortable]="true"
      filterable="menu"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (cancel)="cancelHandler()"
    >
      <ng-template kendoGridToolbarTemplate>
        <button
          type="button"
          icon="plus-outline"
          look="flat"
          kendoGridAddCommand
        >
          Add New Record
        </button>
        <button
          type="button"
          icon="refresh-sm"
          look="flat"
          kendoButton
          class="display-end"
        >
          Refresh
        </button>
      </ng-template>
      <kendo-grid-column
        field="sponsorId"
        title="Sponsor Id"
        width="90"
        filter="numeric"
      >
        <!-- <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup" let-isNew="isNew">
          <input class="k-textbox k-adjust-width" [formControl]="formGroup.get(column.field)" maxlength="50" kendoTextBox />
        </ng-template> -->
      </kendo-grid-column>
      <kendo-grid-column field="sponsorName" title="Sponsor Name" width="150">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="attention" title="Attention" width="100">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="tradingFax" title="Trading Fax" width="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.tradingFax | phone }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <kendo-maskedtextbox
            class="k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            [mask]="phoneMask"
            [promptPlaceholder]="' '"
          ></kendo-maskedtextbox>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="insuranceFax" title="Insurance Fax" width="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.insuranceFax | phone }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <kendo-maskedtextbox
            class="k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            [mask]="phoneMask"
            [promptPlaceholder]="' '"
          ></kendo-maskedtextbox>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="active"
        title="Active"
        width="70"
        filter="boolean"
      >
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.active" disabled />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Command" width="70">
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
        >
          <button kendoGridEditCommand [primary]="true">Edit</button>
          <button kendoGridCancelCommand>Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
 </div></div>
    <!-- Main Container -->
 <div *ngIf="formGroup"  class="card width-30">
  <!-- Header -->
  <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
    Edit
    </h3>
  </div>

  <!-- Card Body -->
  <div class="p-4 no-padding">
    <form
      *ngIf="formGroup"
      class="k-form k-form-horizontal edit-form"
      [formGroup]="formGroup"
      (ngSubmit)="saveHandler($event)"
    >
      <kendo-formfield [orientation]="'horizontal'" class="flex">
        <label class="width-40" for="sponsorName">Sponsor Name: </label>
        <input
          id="sponsorName"
          class="margin-left"
          formControlName="sponsorName"
          maxlength="100"
          kendoTextBox
        />
      </kendo-formfield>
      <kendo-formfield [orientation]="'horizontal'" class="flex">
        <label class="width-40" for="attention">Attention: </label>
        <input
          id="attention"
          class="margin-left"
          formControlName="attention"
          maxlength="100"
          kendoTextBox
        />
      </kendo-formfield>
      <kendo-formfield [orientation]="'horizontal'" class="flex">
        <label class="width-40" for="tradingFax">Trading Fax: </label>
        <kendo-maskedtextbox
          id="tradingFax"
          class="margin-left"
          formControlName="tradingFax"
          [mask]="phoneMask"
        ></kendo-maskedtextbox>
      </kendo-formfield>
      <kendo-formfield [orientation]="'horizontal'" class="flex">
        <label class="width-40" for="insuranceFax">Insurance Fax: </label>
        <kendo-maskedtextbox
          id="insuranceFax"
          class="margin-left"
          formControlName="insuranceFax"
          [mask]="phoneMask"
        ></kendo-maskedtextbox>
      </kendo-formfield>
      <kendo-formfield [orientation]="'horizontal'" class="flex">
        <label class="width-40" for="active">Active: </label>
        <input id="active" type="checkbox" formControlName="active" />
      </kendo-formfield>
      <kendo-formfield
        formArrayName="productTypes"
        *ngFor="
          let productType of productTypeNestedControls.controls;
          let i = index
        "
        [orientation]="'horizontal'"
        class="flex"
      >
        <label class="width-40">{{ productTypes[i].productTypeDesc2 }}: </label>
        <input type="checkbox" [formControlName]="i" />
      </kendo-formfield>
      <button
        kendoButton
        look="outline"
        primary="true"
        type="submit"
        [disabled]="!formGroup.valid"
      >
        Save
      </button>
      <button kendoButton look="outline" (click)="cancelHandler()">
        Cancel
      </button>
    </form>
</div></div>
